import { JSX } from 'react';
import {categoryOptions, categoryProps} from './category';
import WindowBar from '../../common/windowBar/windowBar';
import './categoryDropdown.css';

interface CategoryDropdownProps {
    onCategorySelect: (category: categoryProps) => void;
    onClose?: () => void; // Optional: to close dropdown after selection
}

const CategoryDropdown = ({ onCategorySelect, onClose }: CategoryDropdownProps): JSX.Element => {

  return (
    <div className="category-dropdown-container">
      <div className='main-pixel-container category-dropdown-inner-container'>
        <WindowBar IconSrc={null} title='Categories' onClick={onClose}/>
        <div className='dropdown-divider'></div>
        {categoryOptions.map(category => (
        <div className="type-container" onClick={()=>onCategorySelect(category)}>
            <img className='category-image' src={category.image}></img>
            <p className='category-text'>{category.text}</p>
        </div>
      ))}
      </div>
    </div>
  ); 
};
    
export default CategoryDropdown;